var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMarketspaceFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.778 2a2 2 0 0 0-1.986 1.766l-1.79 15.172A3 3 0 0 0 5 22h14a3 3 0 0 0 2.998-3.062l-1.79-15.172A2 2 0 0 0 18.222 2zM9 8a1 1 0 0 0-2 0 5 5 0 1 0 10 0 1 1 0 1 0-2 0 3 3 0 0 1-6 0",
  clipRule: "evenodd"
})));
export default SvgIcMarketspaceFill;